export default __webpack_public_path__ + "static/media/Boots of Celestial Radiance.530b0513.jpg";